"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeAcronyms = exports.useTheme = exports.getID = exports.generatePricingDataWithDefaultValues = exports.ThemeContextProvider = exports.ThemeContext = exports.TOYOTA_THEME_ACRONYM = exports.TOYOTA_THEME = exports.LEXUS_THEME_ACRONYM = exports.LEXUS_THEME = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const generatePricingDataWithDefaultValues = function () {
  let pricingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    globalTotalMsrpDisclaimer: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.globalTotalMsrpDisclaimer) || "Total MSRP includes delivery, processing and handling fee and may be subject to change at any time. Excludes taxes, title, license and dealer-installed optional equipment. Dealer price will vary.",
    globalDapDisclaimer: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.globalDapDisclaimer) || ``,
    globalMSRPLabel: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.globalMSRPLabel) || "Total MSRP",
    priceDetailsBreakdownHeading: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.priceDetailsBreakdownHeading) || "TOTAL MSRP VEHICLE DETAILS",
    priceDetailsBreakdownHeadingDap: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.priceDetailsBreakdownHeadingDap) || "COST OF VEHICLE",
    priceDetailsModalFooter: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.priceDetailsModalFooter) || "Total MSRP does not reflect the advertised price or sales price of the vehicle. Actual dealer price will vary. Total MSRP includes delivery, processing and handling fee, and may be subject to change at any time. Total MSRP excludes taxes, title, and license. Vehicle may contain additional dealer installed optional equipment and may be subject to additional dealer fees.",
    priceDetailsModalBaseCopy: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.priceDetailsModalBaseCopy) || "base model",
    priceDetailsModalBaseDisclaimer: pricingData === null || pricingData === void 0 ? void 0 : pricingData.priceDetailsModalBaseDisclaimer,
    dphCopy: (pricingData === null || pricingData === void 0 ? void 0 : pricingData.dphCopy) || "delivery processing and handling fee"
  };
};
exports.generatePricingDataWithDefaultValues = generatePricingDataWithDefaultValues;
const getID = function (name) {
  var _name$replaceAll;
  return `${name === null || name === void 0 ? void 0 : (_name$replaceAll = name.replaceAll(/\&amp\;|\&/g, "")) === null || _name$replaceAll === void 0 ? void 0 : _name$replaceAll.replaceAll(/\s+/g, "_")}_filter_block`;
};
exports.getID = getID;
const ThemeContext = exports.ThemeContext = /*#__PURE__*/(0, _react.createContext)("Lexus");
const TOYOTA_THEME = exports.TOYOTA_THEME = "Toyota";
const LEXUS_THEME = exports.LEXUS_THEME = "Lexus";
const TOYOTA_THEME_ACRONYM = exports.TOYOTA_THEME_ACRONYM = "TCOM";
const LEXUS_THEME_ACRONYM = exports.LEXUS_THEME_ACRONYM = "LCOM";
const useTheme = function () {
  return (0, _react.useContext)(ThemeContext);
};
exports.useTheme = useTheme;
const useThemeAcronyms = function () {
  return (0, _react.useContext)(ThemeContext) === TOYOTA_THEME ? TOYOTA_THEME_ACRONYM : LEXUS_THEME_ACRONYM;
};
exports.useThemeAcronyms = useThemeAcronyms;
const ThemeContextProvider = function (_ref) {
  let {
    theme,
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemeContext.Provider, {
    value: theme,
    "data-testid": "ThemeContextProvider",
    children: children
  });
};
exports.ThemeContextProvider = ThemeContextProvider;